import { render, staticRenderFns } from "./helpPersonVideo.vue?vue&type=template&id=f567b454&scoped=true&"
import script from "./helpPersonVideo.vue?vue&type=script&lang=js&"
export * from "./helpPersonVideo.vue?vue&type=script&lang=js&"
import style0 from "./helpPersonVideo.vue?vue&type=style&index=0&id=f567b454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f567b454",
  null
  
)

export default component.exports